import React, { useContext, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { IElement } from '@routes/private/Editor/types';
import Layer from '../Layers/Layer';
import LayerElement from '@components/LayerElement';
import { getParentCategoryColor } from '@utils/selectDescribe';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { findElementById } from '@utils/editor';

const ZIndexStack: React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const data = context.data;
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [layer, setLayer] = useState(-1);

  const layerElements = (artboard: IElement, index: number) => {
    const artboardsZIndexChainRev = [...context.artboardsZIndexChain].reverse();
    const zIndexChain = artboardsZIndexChainRev[index]?.zIndexChain ?? [];

    const stack = [...zIndexChain].reverse().map(elementId => {
      const element = findElementById(artboard.children ?? [], elementId);
      if (element && ['Text', 'Image', 'Shape'].indexOf(element.type) !== -1)
        return (
            <LayerElement 
              key={elementId}
              pickerType={"STACKS"} 
              id={element.id} 
              artboardIndex={artboardsZIndexChainRev[index].artboardIndex}
              HideUnhide={(elementId) => context.onCommandChange("hideUnhide", undefined, [elementId], undefined, undefined, undefined, undefined, 'LAYERS_PICKER')} 
              level={0} 
              selected={context.editorStatus.selectedElementsId.includes(element.id)} 
              isOver={context.editorStatus.overElementId === element.id} 
              onClick={() => context.onSelectedElementsIdChange(element.id)} 
              onOver={(isOver: boolean) => context.onOverElementIdChange(element.id, isOver)} 
              title={element.name} 
              type={element.type} 
              hidden={element.attributes.hidden} 
              parentColor={context.editorStatus.showSelectDescribe && context.editorStatus.showDescribedLayerColor ? getParentCategoryColor(element.id, dsConfig?.selectDescribeConfig.categories, context.selectDescribe?.templateFields, context.selectDescribe?.taggedFields) : undefined}
              locked={element.attributes.locked}
              lockUnlock={(elementId: string, value: boolean) =>  context.onCommandChange("lockUnlockElement",value,[elementId])}
              onEdit={(name:string)=>{handleEditName(element,name);}}
            />
        );
    });
    stack.unshift(
      <LayerElement 
        key={"shadow-first-element"}
        pickerType={"STACKS"} 
        id={"shadow-first-element"}
        artboardIndex={artboardsZIndexChainRev[index].artboardIndex} 
        HideUnhide={() => {}} 
        level={0} 
        selected={false} 
        isOver={false} 
        onOver={undefined} 
        title={""}
        lockUnlock={(elementId: string, value: boolean) =>  {}}
      />
    );
    return stack;
  }

  const handleEditName=(element:IElement, name:string)=>{
    context.onCommandChange("editName", name,[element.id]);    
}


  // ASUMPTION - Should there be only 1 artboards per psd and artboard can not contain another artboard
  const artboards = data[0]?.children ? [...data[0].children.filter(e => e.type === "Artboard")].reverse() : [];

  return (
    <S.Root
      bgColor={!context.editorStatus.showSelectDescribe ? "#ffffff" : undefined}
    >
      <S.Layers>
        {artboards.length > 0 &&
          artboards.map((artboard: IElement, index: number) =>
            <Layer
              index={index}
              title={artboard.name}
              active={layer == index}
              onClick={() => {
                if (index !== layer) setLayer(index);
                else setLayer(-1);
              }}>
              {
                artboard.children && layerElements(artboard, index)
              }
            </Layer>
          )
        }
      </S.Layers>
    </S.Root>
  );
}

export default ZIndexStack;